"use strict";

const extend = require('extend');

function copy(pojso) {
  if (pojso === undefined || pojso == null) {
    return null;
  }

  if (Array.isArray(pojso)) {
    return extend(true, [], pojso);
  }

  if (typeof pojso === 'object') {
    return extend(true, {}, pojso);
  }

  return pojso;
}

function assignFields(dst, src, fields, copyFields = false) {
  const to = dst;
  const from = src;
  fields.forEach(key => {
    if (from[key] !== undefined) {
      if (copyFields) {
        to[key] = copy(from[key]);
      } else {
        to[key] = from[key];
      }
    }
  });
  return to;
}
/**
 * Creates an object that has only the specified keys set to the
 * values in from. If the from[key] is undefined, the key will not
 * be inserted into the object. If ignoreNull is true, nulls will
 * be skipped as well. Note, this only works on top level keys
 * @param {array} keys the keys to pick from the 'from' object
 * @param {object} from the object to take values from
 * @param {boolean} [ignoreNull] (false) if true, null values will not be picked
 */


function pick(keys, from, ignoreNull = false) {
  const r = {};

  if (typeof keys === 'string') {
    if (ignoreNull ? from[keys] != null : from[keys] !== undefined) {
      r[keys] = from[keys];
    }

    return r;
  }

  const len = keys.length;

  for (let n = 0; n < len; n++) {
    const k = keys[n];
    const v = from[k];

    if (ignoreNull ? v != null : v !== undefined) {
      r[k] = v;
    }
  }

  return r;
} // Based on: https://stackoverflow.com/questions/19098797/fastest-way-to-flatten-un-flatten-nested-json-objects


function flatten(obj, options, prefix, current) {
  const opts = typeof options === 'string' ? {
    divider: options
  } : options || {};
  opts.divider = opts.divider || '.';
  opts.removeEmptyObjects = opts.removeEmptyObjects == null ? true : opts.removeEmptyObjects === true;
  opts.arrayIsPrimitive = opts.arrayIsPrimitive == null ? false : opts.arrayIsPrimitive === true;
  const pre = prefix || [];
  const curr = current || {};

  if (pre.length === 0 && (obj === undefined || obj === null)) {
    return {};
  }

  if (typeof obj === 'object' && obj !== null) {
    if (opts.arrayIsPrimitive && Array.isArray(obj)) {
      curr[pre.join(opts.divider)] = obj;
    } else {
      Object.keys(obj).forEach(key => {
        flatten(obj[key], opts, pre.concat(key), curr);
      });
    }
  } else {
    curr[pre.join(opts.divider)] = obj;
  }

  return curr;
}

function unflatten(data, opts) {
  let divider = typeof opts === 'string' || opts == null ? opts : opts.divider;
  divider = divider || '.';

  if (data == null || typeof data !== 'object' || Array.isArray(data)) {
    return data;
  }

  const regex = new RegExp(`\\${divider}?([^\\${divider}\\[\\]]+)|\\[(\\d+)\\]`, 'g');
  const resultholder = {};
  Object.keys(data).forEach(p => {
    let cur = resultholder;
    let prop = '';
    let m = regex.exec(p);

    while (m != null) {
      cur = cur[prop] || (cur[prop] = m[2] ? [] : {});
      prop = m[2] || m[1];
      m = regex.exec(p);
    }

    cur[prop] = data[p];
  });
  return resultholder[''] || resultholder;
} // END SRC


function toPathValue(obj, divider = '/', pathKey = 'path', valueKey = 'value') {
  const f = flatten(obj, divider);
  return Object.keys(f).map((k, i) => {
    return {
      [pathKey]: k,
      [valueKey]: f[k]
    };
  });
}

function fromPathValue(arr, divider = '/', pathKey = 'path', valueKey = 'value') {
  const r = {};

  if (Array.isArray(arr)) {
    arr.forEach(v => {
      r[v[pathKey]] = v[valueKey];
    });
  }

  return unflatten(r, divider);
}

function pathValue(arr, path, dValue) {
  if (Array.isArray(arr)) {
    for (let n = 0; n < arr.length; n++) {
      if (arr[n].path === path) {
        return arr[n].value;
      }
    }
  }

  return dValue;
}

exports.pick = pick;
exports.copy = copy;
exports.assignFields = assignFields;
exports.copyFields = assignFields;
exports.flatten = flatten;
exports.unflatten = unflatten;
exports.toPathValue = toPathValue;
exports.fromPathValue = fromPathValue;
exports.pathValue = pathValue;